import {Component, Input} from '@angular/core';
import {FlexLayoutModule} from '@ngbracket/ngx-layout';
import {UiKitModule} from '@npck/libs/ui-kit';

@Component({
    selector: 'auth-expand-card',
    templateUrl: 'expand-card.component.html',
    styleUrls: ['expand-card.component.scss'],
    standalone: true,
    imports: [UiKitModule, FlexLayoutModule],
})
export class ExpandCardComponent {
    @Input() title = '';
    @Input() expanded = false;

    toggle(): void {
        this.expanded = !this.expanded;
    }
}
